import type { Variants } from "framer-motion";

/**
 * Shared entrance-animation variants for the Automations page stagger-reveal.
 * Mirrors the dashboard feature's motion contract so both surfaces feel
 * consistent: container drives staggerChildren, items fade+rise in.
 */
export const containerVariants: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.06,
      delayChildren: 0.02,
    },
  },
};

export const itemVariants: Variants = {
  hidden: { opacity: 0, y: 10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.35, ease: [0.22, 1, 0.36, 1] },
  },
};

/** Gentle height/opacity expand-collapse for conditional sub-sections. */
export const collapseVariants: Variants = {
  collapsed: { height: 0, opacity: 0 },
  expanded: {
    height: "auto",
    opacity: 1,
    transition: { duration: 0.25, ease: [0.22, 1, 0.36, 1] },
  },
};
